import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BankDto } from '../../../../../../service/dto';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { HttpBankService } from '../../../../../../service/http-bank.service';

@Component({
	selector: 'app-product-edit-bank-account-modal',
	standalone: false,
	templateUrl: './product-edit-bank-account-modal.component.html',
	styleUrl: './product-edit-bank-account-modal.component.scss'
})
export class ProductEditBankAccountModalComponent implements OnInit, OnDestroy {
	@Input() formArray!: FormArray;
	@Input() formControl?: FormGroup;
	mode: 'Edit'|'Create' = 'Create';
	form!: FormGroup;

	availableBanks: BankDto[] = [];

	constructor(private fb: FormBuilder, private modalRef: NzModalRef, private bankService: HttpBankService) { }

	ngOnInit(): void {
		this.bankService.getAll().subscribe(result => this.availableBanks = result);
		const existing = this.formControl?.getRawValue();
		if(existing?.id){
			this.mode='Edit';
		}
		this.form = this.fb.group({
			id: [existing?.id ?? ''],
			fromDate: [existing?.fromDate ?? '', Validators.required],
			toDate: [existing?.toDate ?? ''],
			bank: [existing?.bank ?? '', Validators.required],
			accountNumber: [existing?.accountNumber ?? 0, Validators.required],
			accountName: [existing?.accountName ?? 0, Validators.required]
		});
	}
	ngOnDestroy(): void { }

	onCancel(): void {
		this.modalRef.close();
	}

	onSave(): void {
		if (this.form.invalid) {
			Object.values(this.form.controls).forEach(control => {
				control.markAsDirty();
				control.updateValueAndValidity();
			});
			return;
		}

		const bankAccount = this.form.getRawValue();

		if (this.formControl) {
			// Edit mode — patch the original FormGroup so all its validators are preserved
			this.formControl.patchValue(bankAccount);
		} else {
			// Add mode — push a fresh FormGroup built from the saved values
			this.formArray.push(
				this.fb.group({
					id: [bankAccount.id],
					fromDate: [bankAccount.fromDate, Validators.required],
					toDate: [bankAccount.toDate],
					bank: [bankAccount.bank, Validators.required],
					accountNumber: [bankAccount.accountNumber, Validators.required],
					accountName: [bankAccount.accountName, Validators.required],
				})
			);
		}

		this.modalRef.close(bankAccount);
	}
	compareSelectValues = (o1: any, o2: any): boolean => o1 && o2 ? o1.id === o2.id : o1 === o2;

}
